import { expVal, expValEquals } from '@atlassian/jira-feature-experiments';
import { fireCjnNav4PlacementExposed, type CreateAnalyticsEvent } from '../analytics/index.tsx';
import { jiraUserIsActiveAfterDate } from './jiraUserIsActiveAfterDate.tsx';

const CJN_NAV4_EXPERIMENT_START_DATE = new Date('2026-06-30');

export const isExcludedForNav4Placement = async (
	cloudId: string,
	userId: string,
	createAnalyticsEvent: CreateAnalyticsEvent,
	targetProduct: 'jira_productDiscovery' | 'confluence' | 'loom',
): Promise<boolean> => {
	if (!(await jiraUserIsActiveAfterDate(cloudId, userId, CJN_NAV4_EXPERIMENT_START_DATE))) {
		return false;
	}

	if (
		['control', 'variation'].includes(expVal('puma_expt_cjn-nav4-jira', 'cohort', 'not-enrolled'))
	) {
		fireCjnNav4PlacementExposed(
			createAnalyticsEvent,
			'crossJoinNudgesNav4Placement',
			'puma_expt_cjn-nav4-jira',
			expVal('puma_expt_cjn-nav4-jira', 'cohort', 'not-enrolled'),
			targetProduct,
		);
	}

	return expValEquals('puma_expt_cjn-nav4-jira', 'cohort', 'variation') ?? false;
};
